import { paths } from '@types';
import { axiosInstance } from '@config/axios/axios.config.ts';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { stableKey } from '@common/cache/util.ts';

const reportsDownloadListRequest = async (
  props: paths[`/reporting/downloads`]['get']['parameters']['query'],
) => {
  const response = axiosInstance.get<
    paths[`/reporting/downloads`]['get']['responses']['200']['content']['application/json']
  >(`/reporting/downloads`, {
    params: {
      ...(props?.page && { page: props.page }),
      ...(props?.limit && { limit: props.limit }),
      ...(props?.search && { search: props.search }),
    },
  });
  return (await response).data;
};

export const useReportsDownloadQuery = (
  props: paths[`/reporting/downloads`]['get']['parameters']['query'],
) =>
  useQuery({
    queryKey: ['reportDownloadList', stableKey(props)],
    queryFn: () => reportsDownloadListRequest(props),
    placeholderData: keepPreviousData,
  });

const carePlanDownloadListRequest = async (
  props: paths[`/patient/care-plans/downloads`]['get']['parameters']['query'],
) => {
  const response = axiosInstance.get<
    paths[`/patient/care-plans/downloads`]['get']['responses']['200']['content']['application/json']
  >(`/patient/care-plans/downloads`, {
    params: {
      ...(props?.page && { page: props.page }),
      ...(props?.limit && { limit: props.limit }),
      ...(props?.search && { search: props.search }),
    },
  });
  return (await response).data;
};

export const useCarePlanDownloadQuery = (
  props: paths[`/patient/care-plans/downloads`]['get']['parameters']['query'],
) =>
  useQuery({
    queryKey: ['carePlanDownloadList', stableKey(props)],
    queryFn: () => carePlanDownloadListRequest(props),
    placeholderData: keepPreviousData,
  });
